import {teamInvitesQueryOptions, teamMembersQueryOptions} from '@blesk-frontend/api';
import {useBleskAuth, useTeamSubscription} from '@blesk-frontend/auth';
import {Button, useModal} from '@blesk-frontend/ui';
import {useQuery} from '@tanstack/react-query';
import {useLocation} from '@tanstack/react-router';
import {useMemo} from 'react';
import {PlanPaywallModal} from '@/features/plans';
import {CreateTeamInviteModal} from '@/features/team';

export const TeamInviteButton = () => {
  const {pathname} = useLocation();
  const openCreateTeamInviteModal = useModal((props) => <CreateTeamInviteModal {...props} />);
  const openPaywallModal = useModal((props) => <PlanPaywallModal {...props} />);

  const {
    query: {data: user},
    teamId,
  } = useBleskAuth();

  const {subscription} = useTeamSubscription();
  const {data: teamMembers} = useQuery(teamMembersQueryOptions(teamId || ''));
  const {data: teamInvites} = useQuery(teamInvitesQueryOptions(teamId || ''));

  const isOwner = useMemo(() => {
    return user?.teams.find((team) => team.teamId === teamId)?.role === 'owner';
  }, [user, teamId]);

  const allowInvite = useMemo(() => {
    if (!isOwner || !teamMembers || !teamInvites) {
      return false;
    }
    const isTeamPlan = subscription?.plan?.name.toLowerCase().includes('team');

    return isOwner && (isTeamPlan || teamMembers.length + teamInvites.length < 2);
  }, [isOwner, teamMembers, teamInvites, subscription]);

  if (!isOwner || pathname === '/team') {
    return null;
  }

  return (
    <Button
      className="w-fit px-6"
      variant="outline"
      onClick={() => (allowInvite ? openCreateTeamInviteModal() : openPaywallModal())}
    >
      Пригласить коллегу
    </Button>
  );
};
